import { MembershipCard } from '../models/membership-card.interfaces';

export const SkyMilesMembershipCardMocks: MembershipCard = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-skymiles.png',
    alt: 'Card Image image'
  },
  user: {
    name: 'Rocky Olive',
    skymilesNumber: '8006270311',
    validity: {
      title: 'Valid thru:',
      subtitle: 'JAN 31 2024'
    }
  },
  barcode: {
    alt: 'Barcode Image image',
    src: '/utils/barcode/LinearServlet?BARCODE=8006270311'
  },
  info: 'For reservations, information and online check-in, please visit delta.com or call 1-800-323-2323 (US, Canada, Puerto Rico, U.S. Virgin Islands). For all other countries, contact your local Delta Reservations office.',
  rules:
    'All SkyMiles program rules apply. To review the rules, please visit delta.com/member'
};

export const SilverMembershipCardMocks: MembershipCard = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-silver.png',
    alt: 'Card Image image'
  },
  user: {
    name: 'Rocky Olive',
    skymilesNumber: '8006270311',
    validity: {
      title: 'Valid thru:',
      subtitle: 'JAN 31 2024'
    }
  },
  barcode: {
    alt: 'Barcode Image image',
    src: '/utils/barcode/LinearServlet?BARCODE=8006270311'
  },
  info: 'For reservations, information and online check-in, please visit delta.com or call 1-800-323-2323 (US, Canada, Puerto Rico, U.S. Virgin Islands). For all other countries, contact your local Delta Reservations office.',
  rules:
    'All SkyMiles program rules apply. To review the rules, please visit delta.com/member'
};

export const PlatinumMembershipCardMocks: MembershipCard = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-platinum.png',
    alt: 'Card Image image'
  },
  user: {
    name: 'Rocky Olive',
    skymilesNumber: '8006270311',
    validity: {
      title: 'Valid thru:',
      subtitle: 'JAN 31 2024'
    }
  },
  barcode: {
    alt: 'Barcode Image image',
    src: '/utils/barcode/LinearServlet?BARCODE=8006270311'
  },
  info: 'For reservations, information and online check-in, please visit delta.com or call 1-800-323-2323 (US, Canada, Puerto Rico, U.S. Virgin Islands). For all other countries, contact your local Delta Reservations office.',
  rules:
    'All SkyMiles program rules apply. To review the rules, please visit delta.com/member'
};

export const GoldMembershipCardMocks: MembershipCard = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-gold.png',
    alt: 'Card Image image'
  },
  user: {
    name: 'Rocky Olive',
    skymilesNumber: '8006270311',
    validity: {
      title: 'Valid thru:',
      subtitle: 'JAN 31 2024'
    }
  },
  barcode: {
    alt: 'Barcode Image image',
    src: '/utils/barcode/LinearServlet?BARCODE=8006270311'
  },
  info: 'For reservations, information and online check-in, please visit delta.com or call 1-800-323-2323 (US, Canada, Puerto Rico, U.S. Virgin Islands). For all other countries, contact your local Delta Reservations office.',
  rules:
    'All SkyMiles program rules apply. To review the rules, please visit delta.com/member'
};

export const DiamondMembershipCardMocks: MembershipCard = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-diamond.png',
    alt: 'Diamond Medallion Digital Membership Card image'
  },
  user: {
    name: 'Rocky Olive',
    skymilesNumber: '8006270311',
    validity: {
      title: 'Valid thru:',
      subtitle: 'JAN 31 2024'
    }
  },
  barcode: {
    alt: 'Barcode Image image',
    src: '/utils/barcode/LinearServlet?BARCODE=8006270311'
  },
  info: 'For reservations, information and online check-in, please visit delta.com or call 1-800-323-2323 (US, Canada, Puerto Rico, U.S. Virgin Islands). For all other countries, contact your local Delta Reservations office.',
  rules:
    'All SkyMiles program rules apply. To review the rules, please visit delta.com/member'
};

export const Delta360MembershipCardMocks: MembershipCard = {
  image: {
    src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/digital-membership-card-360.png',
    alt: 'Delta 360 Digital Membership Card Image image'
  },
  user: {
    name: 'Rocky Olive',
    skymilesNumber: '8006270311',
    validity: {
      title: 'Valid thru:',
      subtitle: 'JAN 31 2024'
    }
  },
  barcode: {
    alt: 'Barcode Image image',
    src: '/utils/barcode/LinearServlet?BARCODE=8006270311'
  },
  info: 'For reservations, information and online check-in, please visit delta.com or call 1-800-323-2323 (US, Canada, Puerto Rico, U.S. Virgin Islands). For all other countries, contact your local Delta Reservations office.',
  rules:
    'All SkyMiles program rules apply. To review the rules, please visit delta.com/member'
};
